import React from "react";
import { DragLayer } from "react-dnd";
var layerStyles = {
  position: "fixed",
  pointerEvents: "none",
  zIndex: 100,
  left: 0,
  top: 0,
  width: "100%",
  height: "100%"
};

function getItemStyles(props) {
  var currentOffset = props.currentOffset,
      scale = props.scale;

  if (!currentOffset) {
    return {
      display: "none"
    };
  }

  var size = 175 * scale + "px";
  var x = currentOffset.x,
      y = currentOffset.y;
  var transform = "translate(" + x + "px, " + y + "px)";
  return {
    transform: transform,
    WebkitTransform: transform,
    width: size,
    height: size,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  };
}

function CustomDragLayer(props) {
  var item = props.item,
      isDragging = props.isDragging,
      itemType = props.itemType;

  if (!isDragging) {
    return null;
  }

  switch (itemType) {
    case "GraphicAsset":
      return React.createElement("div", {
        style: layerStyles
      }, React.createElement("div", {
        style: getItemStyles(props)
      }, React.createElement("img", {
        style: {
          maxWidth: "100%",
          maxHeight: "100%"
        },
        src: item.url
      })));

    case "GraphicAssetTrackBar":
      item.component.setCurrentPosition(props.currentOffset.x);
      return null;

    default:
      return null;
  }
}

function collect(monitor) {
  return {
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging()
  };
}

export default DragLayer(collect)(CustomDragLayer);